import React, { useState } from "react";
import { BiChevronDown } from "react-icons/bi";

interface CarModelItemProps {
  name: string;
  description: string;
}

const CardList: React.FC<CarModelItemProps> = ({ name, description }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div
        className="flex items-center px-4 py-2 bg-white cursor-pointer max-md:max-w-full"
        onClick={() => setOpen(!open)}
      >
        <div className="flex-1 break-words pr-4">{name}</div>
        <BiChevronDown
          size={28}
          className={`flex-shrink-0 transition-all duration-300 ease-in-out ${
            open ? "rotate-180" : ""
          }`}
        />
      </div>
      <div
        className={`transition-all duration-700 ease-in-out overflow-hidden ${
          open ? "max-h-[800px]" : "max-h-0"
        }`}
      >
        <p className="p-4 border-t-2">{description}</p>
      </div>
    </>
  );
};

export default CardList;
